var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle"},[_c('div',{staticClass:"circle-percent-text-body"},[_c('span',{staticClass:"percent-text",style:({ 'font-size': _vm.percentFontSize })}),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }